var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
defineWellKnownSymbol('patternMatch');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/esnext.symbol.pattern-match.js
// module id = 938
// module chunks = 3